import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const reqMastersAdapter = createEntityAdapter({})

const initialState = reqMastersAdapter.getInitialState()

export const reqMasterApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getReqMasters: builder.query({
            query: () => ({
                url: '/requestmaster',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedReqMasters = responseData.map(reqmaster => {
                    // console.log(assetmaster)
                    reqmaster.id = reqmaster._id
                    // console.log(assetmaster)
                    return reqmaster
                });
                return reqMastersAdapter.setAll(initialState, loadedReqMasters)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Reqmaster', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Reqmaster', id }))
                    ]
                } else return [{ type: 'Reqmaster', id: 'LIST' }]
            }
        }),
        addNewReqMaster: builder.mutation({
            query: initialUserData => ({
                url: '/requestmaster',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'Reqmaster', id: "LIST" }
            ]
        }),
        updateReqMaster: builder.mutation({
            query: initialUserData => ({
                url: '/requestmaster',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Reqmaster', id: arg.id }
            ]
        }),
        addSubInReqCat: builder.mutation({
            query: initialUserData => ({
                url: '/requestmaster/addsubject',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Reqmaster', id: arg.id }
            ]
        }),
       delReqSubInArr: builder.mutation({
            query: initialUserData => ({
                url: '/requestmaster/deletesubject',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Reqmaster', id: arg.id }
            ]
        }),
        // editAssetOfCat: builder.mutation({
        //     query: initialUserData => ({
        //         url: '/complmaster/editasset',
        //         method: 'PUT',
        //         body: {
        //             ...initialUserData,
        //         }
        //     }),
        //     invalidatesTags: (result, error, arg) => [
        //         { type: 'Assetmaster', id: arg.id }
        //     ]
        // }),
        deleteReqMaster: builder.mutation({
            query: ({ id }) => ({
                url: `/requestmaster`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Reqmaster', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetReqMastersQuery,
    useAddNewReqMasterMutation,
    useUpdateReqMasterMutation,
    useDelReqSubInArrMutation,
    useAddSubInReqCatMutation,
    useDeleteReqMasterMutation
} = reqMasterApiSlice

// returns the query result object
export const selectReqMastersResult = reqMasterApiSlice.endpoints.getReqMasters.select()

// creates memoized selector
const selectReqMastersData = createSelector(
    selectReqMastersResult,
    reqMastersResult => reqMastersResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllReqMasters,
    selectById: selectReqMasterById,
    selectIds: selectReqMasterIds
    // Pass in a selector that returns the users slice of state
} = reqMastersAdapter.getSelectors(state => selectReqMastersData(state) ?? initialState)